export default __webpack_public_path__ + "static/media/blue-down-arrow.0506c6d9.svg";